export default "__VITE_ASSET__CaSprGfs__"